export default {
  support_title: "دعم العملاء",
  email: "البريد الإلكتروني",
  role: "الدور",
  issue: "المشكلة",
  select_issue: "اختر المشكلة",
  message: "الرسالة",
  attach_file: "إرفاق ملف",
  confirm_info: "أؤكد أن المعلومات صحيحة",
  cancel: "إلغاء",
  submit: "إرسال",
  track_status: "تتبع الحالة",
  hide_status: "إخفاء الحالة",
  ticket_id: "المعرف",
  status: "الحالة",
  back: "رجوع",
  download: "تحميل",
  reply: "رد",

  fill_required: "يرجى تعبئة جميع الحقول المطلوبة",
  ticket_success: "تم إرسال التذكرة بنجاح",
  error: "خطأ",
  unauthorized: "غير مصرح. يرجى تسجيل الدخول مرة أخرى",
  download_failed: "فشل التحميل",
  attach_file: "إرفاق ملف",
confirm_info: "أؤكد أن المعلومات صحيحة",
};